import { isDeepEqual } from '@attain-apps/data-utils'
import type * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type * as dms from '../../../../dms'
import type * as clusters from '../../clusters'
import type { TypeParams } from '../types'

/**
 * Whenever the current cluster's assignedSpaceIds change, writes a spaceFilter
 * that restricts this collection to those leaf record IDs.
 */
export const setAssignedRecordsFilter = store.effects.create(
  (
    _: ec.Collection<TypeParams>['feature'],
    collection: ec.Collection<TypeParams>,
    clustersEc: clusters.Collection,
    schemaFeature: dms.schema.Feature,
  ) =>
    rxjs
      .combineLatest({
        cluster:
          clustersEc.plugins.currentEntityPlugin.feature.selectors.getEntity()
            .asObservable,
        schema: schemaFeature.selectors.schema.asObservable,
      })
      .pipe(
        rxjs.filter(
          ({ schema }) => !!schema?.tryGetLeafEntityOf('dim::!space'),
        ),
        rxjs.distinctUntilChanged(isDeepEqual),
        // delay(0) guards against a race on cluster switch: the context change that
        // fires this combineLatest also synchronously resets appliedParams in the same
        // tick. Without the delay, that reset runs after our write and clears the
        // spaceFilter. Deferring to the next macrotask ensures we always write after
        // the reset, not before it.
        rxjs.delay(0),
        rxjs.map(({ cluster, schema }) =>
          collection.plugins.currentListPlugin.appliedParams.actions.writeAllProperties
            .from('setAssignedRecordsFilter (effect)')
            .create({
              values: {
                filters: cluster
                  ? {
                      spaceFilter: {
                        entityId: schema.getLeafEntityOf('dim::!space').id,
                        recordIds: cluster.assignedSpaceIds,
                      },
                    }
                  : {},
              },
            }),
        ),
      ),
)
